import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-blocked',
  templateUrl: './blocked.component.html',
  styleUrls: ['./blocked.component.scss']
})
export class BlockedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
